/* eslint-disable no-var, no-restricted-globals, prefer-arrow-callback, prefer-template */
/**
 * Component delivery-slot-picker.js
 *
 * Allows users to pick a deliver slot
 * //todo make real component
 *
 * @type module.exports}
 */

import React from 'react';
import ReactDOM from 'react-dom';

import AddToBasketButtonWithAjaxCall
  from './components/react/AddToBasket/AddToBasketButtonWithAjaxCall.jsx';

import { psaVariants, PSA_SWITCHED_OFF }
  from './components/react/PopupStyleAttach/components/PSAPopup/PSAPopup';

var _each = require('lodash.foreach'); // eslint-disable-line no-underscore-dangle
var resolveByCountry = require('@dc/ui-library/src/helpers/environment').resolveByCountry;
var dayjs = require('dayjs');
var AdvancedFormat = require('dayjs/plugin/advancedFormat');
var Analytics = require('./analytics');
var LocationService = require('./locationservice');
var DeliveryDayCalendar =
  require('./components/native/delivery-day-calendar/delivery-day-calendar.es6').default;

var DeliveryDayCalendarSelectedDate; // this is the only prop that changes that we pass to the DeliveryDayCalendar
var deliveryTypeaheadState = require('./delivery-typeahead-state');
var Product = require('./product');

var uiSettings = require('./utils/UISettings.js');
var uiLocale = require('./utils/UILocale.js');

var productAvailability;

var deliverySlotPicker;
var $datepickerTrigger;
var $timeSlotsLists;
var $deliverySddSlotsMessage;
var $freeDeliveryButtonFooter;
var $datepickerTriggerInputField;
var $freeDeliveryButtonSelector;

var thisMonth;
var earliestSelectableDate;
var currentlySelectedDate;
var slotDates = [];
var selectedDaySlotData = [];
var deliverySlots = {};

var fupid;
var sameDay;
var nextDay;
var countdownSameDay;
var countdownNextDay;
var countdownPlaceholderMCD;

dayjs.extend(AdvancedFormat); // for using 'Do, in formatting date

let psaVariant = PSA_SWITCHED_OFF;
const psaForMcdEnabled = uiSettings.get('component.psa.mcd');
if (psaForMcdEnabled) {
  psaVariant = psaVariants[uiSettings.get('component.psa.variant')];
}

// Stores DOM elements in variables
function jQueryCache() {
  deliverySlotPicker = document.getElementsByClassName('delivery-slot-picker');

  // there is no datapicker for Ireland
  if (resolveByCountry(true, false)) {
    $datepickerTrigger = $('.datepicker-trigger');
    $datepickerTriggerInputField = $('.selected-delivery-date');
  } else {
    $('.datepicker-trigger-wrapper').hide();
  }

  fupid = document.querySelector('div.mcd-home-delivery').dataset.fupid;
  $timeSlotsLists = $('ul.selected-delivery-day-time-slots');
  $deliverySddSlotsMessage = $('div.delivery-sdd-slots-message');
  $freeDeliveryButtonSelector = $('[data-component="free-delivery-button"]');
  $freeDeliveryButtonFooter = $('div.free-delivery-button-footer');
  countdownPlaceholderMCD = $('.countdown-placeholder-mcd');
  countdownSameDay = countdownPlaceholderMCD.find('[data-delivery-type="same-day"]');
  countdownNextDay = countdownPlaceholderMCD.find('[data-delivery-type="next-day"]');
}

// Populate the datepicker input field with the selected delivery
// date in a readable format, defaulting to first available slot date
export function receiveDeliverySlots(data, _productAvailability) {
  productAvailability = _productAvailability;
  DeliveryDayCalendarSelectedDate = dayjs(
    data[0].deliverySlots[data[0].deliverySlots.length - 1].date
      ? data[0].deliverySlots[data[0].deliverySlots.length - 1].date.replace(/\//g, '-')// replace converts 'YYYY/MM/DD' to 'YYYY-MM-DD'
      : null
  );

  jQueryCache();

  // clear SDD message
  $deliverySddSlotsMessage.empty().hide();

  deliverySlots = data;
  thisMonth = new Date();
  thisMonth.setDate(1);

  earliestSelectableDate = dayjs(getFirstAvailableDeliveryDate(deliverySlots));
  currentlySelectedDate = new Date(getFirstAvailableDeliveryDate(deliverySlots));

  sameDay = new Date();
  sameDay.setHours(0, 0, 0, 0);
  nextDay = new Date();
  nextDay.setHours(0, 0, 0, 0);
  nextDay.setDate(nextDay.getDate() + 1);

  updateCountdownVisibility();

  selectedDaySlotData = getDeliverySlots(deliverySlots, DeliveryDayCalendarSelectedDate);

  if ($freeDeliveryButtonSelector.length > 0) {
    initFreeDeliveryButtons();
  }

  populateTimeSlots();

  // there is no datapicker for Ireland
  if (resolveByCountry(true, false)) {
    populateDatepickerTriggerInputField();
    calendarTriggerHandler();
  }

  // adding delivery slots to analytics for smallboxes and bigboxes
  if (_productAvailability.getProductType() === 'SMALLBOX' ||
    _productAvailability.getProductType() === 'BIGBOX') {
    Analytics.addDeliverySlotsToAnalytics(deliverySlots, _productAvailability.getProductType());
  }

  // there is no datapicker for Ireland
  if (resolveByCountry(true, false)) {
    // todo potentially move this to the calender by adding listener
    // and event target interface to cal
    document.addEventListener('mouseup', newMCDcalendarDayTriggerHandler);
  }
}

// Shows selected date in the field
function populateDatepickerTriggerInputField() {
  $datepickerTriggerInputField.html(DeliveryDayCalendarSelectedDate.format('dddd Do MMMM')); // TODO: refactor to vanillajs .innerHTML when single selector
}

// Gets first and last avaiable delivery date
function getFirstAndLastAvailableDeliveryDate(slotData) {
  var firstAvailableSlotDate = null;
  var lastAvailableSlotDate = null;
  $(slotData).each(function each(i, slot) {
    var dt = new Date(slot.deliverySlots[slot.deliverySlots.length - 1].date);
    if (firstAvailableSlotDate === null || dt.getTime() < firstAvailableSlotDate.getTime()) {
      firstAvailableSlotDate = dt;
    }
    if (lastAvailableSlotDate === null || dt.getTime() > lastAvailableSlotDate.getTime()) {
      lastAvailableSlotDate = dt;
    }
  });
  return { firstDate: firstAvailableSlotDate, lastDate: lastAvailableSlotDate };
}

// Gets first available delivery date as string
export function getFirstAvailableDeliveryDate(slotData) {
  return getFirstAndLastAvailableDeliveryDate(slotData).firstDate.toISOString();
}

/**
 *
 * @param slotData
 * @param {dayjs} date
 * @returns {object}
 */
function getDeliverySlots(slotData, date) {
  var regularSlots = [];
  var yr;
  var mn;
  var dy;
  var freeSlot = null;
  slotDates = [];
  _each(slotData, function each(slot) {
    var dt = new Date(slot.deliverySlots[slot.deliverySlots.length - 1].date);
    var currentRegularSlots = [];
    var currentFreeSlot = null;
    slotDates.push(dt.getTime()); // for comparison purposes
    yr = date.year();
    mn = date.month() + 1;
    dy = date.date();
    if (String(mn).length < 2) {
      mn = '0' + mn;
    }
    if (String(dy).length < 2) {
      dy = '0' + dy;
    }
    _each(slot.deliverySlots, function innerEach(dSlot) {
      if (dSlot.freeDelivery === true) {
        currentFreeSlot = dSlot;
      } else {
        currentRegularSlots.push(dSlot);
      }
    });
    if (currentRegularSlots[0].date === yr + '/' + mn + '/' + dy) {
      regularSlots = currentRegularSlots;
      freeSlot = currentFreeSlot;
    }
  });

  return {
    regularSlots: regularSlots,
    freeSlot: freeSlot
  };
}

// Displays the calendar
function calendarTriggerHandler() {
  $datepickerTrigger.off('click').not('.disabled').on('click', function clickHandler() {

    var viewportWidth = window.innerWidth || document.documentElement.clientWidth ||
      document.body.clientWidth;

    var query = viewportWidth > 1024 ? '#product-actions .datepicker-trigger-wrapper'
      : '#product-actions-touch .datepicker-trigger-wrapper';
    var targetCalendarWillPointTo = document.querySelector(query);

    var deliveryDayCalendar = new DeliveryDayCalendar(
      deliverySlots,
      DeliveryDayCalendarSelectedDate,
      targetCalendarWillPointTo
    );
    deliveryDayCalendar.show();

    // todo display background over lay as 100% x 100% over body under cal
  });

  // Blur on focus to remove carret from field
  $datepickerTriggerInputField.on('focus', function deliverySlotDatepickerInputOnFocus() {
    $(this).blur();
  });
}

/**
 * Give a spinner with delay to give the user an impression something is changing (it is
 * ,its just that it happens instantly)
 */
function fakeApiDelay() {

  /**
   * this toggles the visibility via css by adding a data- attr
   * @param {boolean }state
   */
  function setVisibilityOfSlots(state) {
    _each(document.getElementsByClassName('delivery-slot-picker'), function each(item) {
      item.setAttribute('data-pending-slot-check', state);
    });
    _each(document.querySelectorAll('.tabs-content div.free-delivery'), function each(item) {
      item.setAttribute('data-pending-slot-check', state);
    });
  }

  setVisibilityOfSlots(true);
  setTimeout(function setTimeout() {
    setVisibilityOfSlots(false);
  }, 2000);
}

/**
 *  When selecting a deliverable day (as highlighted in the calendar),
 *  close the datepicker, populate the input field with the selection
 *  and retreive the appropriate delivery slot data from the previously
 *  fetched array to reset and populate the delivery slot list
 */
function newMCDcalendarDayTriggerHandler(event) {

  var oldDate = DeliveryDayCalendarSelectedDate.clone();
  // any click on the calendar or the body will close the calendar, we just inspect the target to
  // determine what action to take
  if (event.target.getAttribute('data-date') && !!event.target.className.match('deliverable')) {

    DeliveryDayCalendarSelectedDate = dayjs(
      event.target.getAttribute('data-date').replace(/\//g, '-')
    );

    if (!areTwoDayJSDatesInSameDay(oldDate, DeliveryDayCalendarSelectedDate)) {

      fakeApiDelay();

      setDatesHeaderEarliest(DeliveryDayCalendarSelectedDate.format('YYYY/MM/DD') ===
        earliestSelectableDate.format('YYYY/MM/DD'));
      populateDatepickerTriggerInputField();
      // Update delivery time slots for selected day
      selectedDaySlotData = getDeliverySlots(deliverySlots, DeliveryDayCalendarSelectedDate);
      $timeSlotsLists.empty();
      $deliverySddSlotsMessage.empty().hide();
      populateTimeSlots();
      currentlySelectedDate = new Date(event.target.getAttribute('data-date'));
      updateCountdownVisibility();
    }
  }
}

// Show countdown only when the next day date is chosen in calendar
function updateCountdownVisibility() {
  if (currentlySelectedDate.getTime() === sameDay.getTime()) {
    countdownSameDay.show();
    countdownNextDay.hide();
  } else if (currentlySelectedDate.getTime() === nextDay.getTime()) {
    countdownSameDay.hide();
    countdownNextDay.show();
  } else {
    countdownSameDay.hide();
    countdownNextDay.hide();
  }
}

function initFreeDeliveryButtons() {

  // data attributes are the same for both desktop/touch versions
  const dataAttributes = $freeDeliveryButtonSelector[0].dataset;

  // Cycle is here because there is each button for desktop/touch versions so it runs always twice
  $freeDeliveryButtonSelector.each((i, freeDeliveryButtonElement) => {
    ReactDOM.render(
      <AddToBasketButtonWithAjaxCall
        buttonPlacementID={'mcd'}
        psaVariant={psaVariant}
        fupid={dataAttributes.fupid}
        quantity={1}
        deliverySlotLabel={' '}
        deliverySlotPrice={' '}
        deliverySlotId={' '}
        deliverySlotPostCode={' '}
        deliverySlotDate={' '}
        buttonLabel={dataAttributes.buttonLabel}
        full={false}
        beforeAddingToBasket={Analytics.dispatchFreeDeliveryOptionSelected}
      />,
      freeDeliveryButtonElement
    );
  });
}

// Populates the delivery times for the selected
// delivery day as a list beneath the datepicker trigger
// todo use a component instead?
function populateTimeSlots() {
  var isExistsSddSlot = false;

  $timeSlotsLists.empty();
  $deliverySddSlotsMessage.empty().hide();

  if (!selectedDaySlotData.regularSlots.length) {
    // only the free slot is shown
    _each(deliverySlotPicker, function each(item) {
      item.setAttribute('data-noSlots', true);
    });
  } else {
    _each(deliverySlotPicker, function each(item) {
      item.setAttribute('data-noSlots', false);
    });

    $timeSlotsLists.each(function jQueryEach(index, timeSlotsListEl) {
      _each(selectedDaySlotData.regularSlots, function each(slot) {
        appendSlotButton($(timeSlotsListEl), slot);
        if (slot.samedaydelivery) {
          isExistsSddSlot = true;
        }
      });
    });

    if (isExistsSddSlot) {
      addContentToDeliverySddSlotsMessage();
    }

    if (productAvailability.getProductType() === 'BIGBOX' && selectedDaySlotData.freeSlot) {
      appendFreeDeliverySlotButton($timeSlotsLists, selectedDaySlotData.freeSlot);
    }

  }

  if (selectedDaySlotData.regularSlots.length > 0) {
    $freeDeliveryButtonFooter.show();
  } else {
    $freeDeliveryButtonFooter.hide();
  }
}

function sendAnalyticsAfterChoosingSlot(deliveryTimeslot) {
  Analytics.track('FULFILLMENT_METHOD', 'Delivered');
  if (typeof deliveryTimeslot !== 'undefined') {
    Analytics.track('DELIVERY_TIMESLOT', deliveryTimeslot);
  }
  Analytics.track('POSTCODE_SEARCH_TYPE',
    deliveryTypeaheadState.selectedSuggestion.inputMethodIsGeoCode);
  Analytics.track('POSTCODE_SEARCH_VALUE',
    deliveryTypeaheadState.selectedSuggestion.valueDisplayed);
  Analytics.track('POSTCODE_SEARCH_VALUE_TYPE',
    deliveryTypeaheadState.selectedSuggestion.inputTypeIsPostCode);
}

function appendFreeDeliverySlotButton($target, slot) {
  var formattedDate = dayjs(new Date(slot.date)).format('Do MMMM');
  var li = document.createElement('li');

  li.className = 'delivery-slot';
  li.innerHTML = '<div data-component="free-delivery-slot-button"' +
                      'class="wrapper free-delivery-button">' +
                  '</div>' +
                  '<span class="free-delivery-date">' +
                      window.App.locale.getFormattedString(
                        'component.deliveryslotpicker.free.label',
                        { date: formattedDate }
                      ) +
                  '</span>';

  $target.append(li);

  // Cycle is here because there is each button for desktop/touch versions so it runs always twice
  $target.find('div[data-component="free-delivery-slot-button"]').each((i, buttonElement) => {
    ReactDOM.render(
      <AddToBasketButtonWithAjaxCall
        buttonPlacementID={'mcd'}
        psaVariant={psaVariant}
        fupid={fupid}
        quantity={1}
        deliverySlotLabel={slot.label}
        deliverySlotPrice={slot.price}
        deliverySlotId={slot.id}
        deliverySlotPostCode={LocationService.getLocation().postcode}
        deliverySlotDate={slot.date}
        buttonLabel={window.App.locale.getString('component.deliveryslotpicker.free.button')}
        full={false}
        beforeAddingToBasket={() => {
          sendAnalyticsAfterChoosingSlot(slot.label);
        }}
      />,
      buttonElement
    );
  });
}

function appendSlotButton($target, slot) {
  var buttonContainer;

  var li = document.createElement('li');
  li.className = 'delivery-slot';
  li.innerHTML = '<div class="wrapper text">' +
        slot.label +
        '<br>' +
        '<span class="price">' +
          slot.price +
        '</span>' +
      '</div>' +
      '<div data-component="delivery-slot-button"></div>';

  $target.append(li);

  buttonContainer = li.querySelector('div[data-component="delivery-slot-button"]');

  ReactDOM.render(
    <AddToBasketButtonWithAjaxCall
      buttonPlacementID={'mcd'}
      psaVariant={psaVariant}
      fupid={fupid}
      quantity={1}
      deliverySlotLabel={slot.label}
      deliverySlotPrice={slot.price}
      deliverySlotId={slot.id}
      deliverySlotPostCode={LocationService.getLocation().postcode}
      deliverySlotDate={slot.samedaydelivery === true ? undefined : slot.date}
      sameDayDelivery={slot.samedaydelivery === true
        ? JSON.stringify(createSddJson(slot, LocationService.getLocation().postcode))
        : undefined}
      buttonLabel={
        uiLocale.getString('component.mcd.postcodechecker.select.delivery.slot.button')
      }
      full={false}
      beforeAddingToBasket={() => {
        sendAnalyticsAfterChoosingSlot(slot.label);
      }}
    />,
    buttonContainer
  );
}

function addContentToDeliverySddSlotsMessage() {
  var message = uiLocale.getString(
    'component.postcode.checker.sdd_flexible_credit_wont_allowed'
  );
  $deliverySddSlotsMessage.text(message).show();
}

function createSddJson(slotData, postcode) {
  var productDelivery = document.querySelector('.check-delivery-options');
  var product = new Product(productDelivery.getAttribute('data-productid'));

  var sddData = {};
  sddData[product.__productId] = { // eslint-disable-line no-underscore-dangle
    readyAt: slotData.readyAt,
    storeNumber: slotData.storeNumber,
    storeId: slotData.storeId,
    timeSlotValueObjects: [
      {
        id: slotData.id,
        expireDate: slotData.expireDate,
        startDate: slotData.startDate,
        endDate: slotData.endDate,
        addedAt: slotData.addedAt
      }
    ],
    price: slotData.price,
    postcode: postcode,
    uuid: slotData.uuid
  };
  return sddData;
}

/**
 * sets the header text
 * @param {boolean} isEarliest
 */
function setDatesHeaderEarliest(isEarliest) {
  if (isEarliest !== undefined) {
    _each(deliverySlotPicker, function each(item) {
      item.setAttribute('data-showearlytext', isEarliest);
    });
  }
}

// check if two dayjs dates are the same
// e. g. if date1=1.1.2015 12:50am date2=1.1.2015 06:00pm => returns true
// e. g. if date1=1.1.2015 date2=10.3.2016 => returns false
function areTwoDayJSDatesInSameDay(date1, date2) {
  return date1.year() === date2.year() &&
    date1.month() === date2.month() &&
    date1.date() === date2.date();
}
